<template>
    <div>
        <SimpleTable formclass="pages/LoadBalance/form" endpoint="api/v2/load-balance" inlineToggle :aditionalColumns="headers" @saveItem="forceSyncServer">
            <template v-slot>
                <h1>Balanceamento de carga</h1>
                <v-divider class="mb-4" />
                <v-alert icon="info" prominent text type="info">
                    Forçar o carregamento das configurações nos servidores:

                    <div v-if="servers && servers.length > 0">
                        <v-btn v-for="server in servers" :key="server" @click="syncServer(server)" color="info" small class="ma-1">
                            <v-icon small left>sync</v-icon>
                            {{ server }}
                        </v-btn>
                    </div>
                </v-alert>

            </template>

            <!-- Template para mostrar quantidade de servidores -->
            <template v-slot:extra-column="item">
                <v-btn color="primary" small outlined @click="openMonitor(item)" v-if="item.enable">
                    <v-icon small left>monitor</v-icon>
                    Monitorar
                </v-btn>
                <v-chip v-else color="grey" text-color="white" small>
                    <v-icon small left>monitor</v-icon>
                    Desativado
                </v-chip>
            </template>

            <template v-slot:more-extra-column="item">
                <v-chip v-if="item.config.chargers && item.config.chargers.length > 0" color="success" text-color="white" small>
                    <v-icon small left>ev_station</v-icon>
                    {{ item.config.chargers.length }}
                </v-chip>
                <v-chip v-else color="grey" text-color="white" small>
                    <v-icon small left>ev_station</v-icon>
                    0
                </v-chip>

            </template>
        </SimpleTable>

        <MonitorModal :show="showMonitorModal" :group="selectedMonitorGroup" @close="closeMonitorModal" />
        <ConfirmModal ref="confirm" />
    </div>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
import MonitorModal from "@/pages/LoadBalance/monitorModal";
import ConfirmModal from "@/components/core/ConfirmModal";
import servers from "@/assets/json/servers.json";

export default {
    components: { SimpleTable, MonitorModal, ConfirmModal },

    data() {
        return {
            servers,
            showMonitorModal: false,
            selectedMonitorGroup: null,
            headers: [
                { text: "Habilitado", value: "enable", align: "right", sortable: false },
                { text: "Monitorar", value: "extra-column", align: "center", sortable: false },
                { text: "Carregadores", value: "more-extra-column", align: "center", sortable: false },
                { text: "Nome", value: "name", align: "right", sortable: true },
            ],
        };
    },

    methods: {
        openMonitor(item) {
            this.selectedMonitorGroup = item;
            this.showMonitorModal = true;
        },

        closeMonitorModal() {
            this.showMonitorModal = false;
            this.selectedMonitorGroup = null;
        },

        forceSyncServer(item) {
            console.log("forceSyncServer", item);
            if (item && item.server) {
                this.syncServer(item.server);
            }
        },

        syncServer(server) {
            if (server) {
                this.$refs.confirm
                    .open("Tem certeza?", "Deseja forçar o carregamento das configurações? \n\n Isso forçará a atualização das configurações de balanceamento de carga no servidor, mesmo que não haja alterações.")
                    .then((confirm) => {
                        if (confirm) {
                            this.$http
                                .postDynamic(server, "api/v2/loadBalance/reload", {})
                                .then(() => {
                                    this.$eventHub.$emit("msgSuccess", "Solicitação de sincronização enviada com sucesso.");
                                }).catch((error) => {
                                    this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao enviar, tente novamente.");
                                });
                        }
                    });
            } else {
                this.$eventHub.$emit("msgError", "Falta configuração do servidor.");
            }
        },
    },
};
</script>